export class ProductsState {
    products: Product[] = [];
    currentProductSlug: string = null;
    isInitialized: boolean = false;
}

export interface Product {
    id: string;
    slug: string;
    name: string;
}
